import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import React, { useEffect, useState } from 'react'
import { t } from 'i18next'

const AccessibleStorehousesCheck = ({ accessibleStorehouses , accessibleLocations  }) => {
    const [isValid, setIsValid] = useState(false)
    useEffect(() => {
        setIsValid(!!accessibleLocations.length || !!accessibleStorehouses.length)
    }, [accessibleStorehouses , accessibleLocations ])

    return (
        <>
            <StyledCircleCheckIconWrapper>
                <CircleCheckIcon variant={isValid ? 'optional' : 'none'} />
            </StyledCircleCheckIconWrapper>
            <span>{t('storehouseTree:storehouse')}</span>
        </>
    )
}

export default AccessibleStorehousesCheck